// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__JdW1U","status":"style_status__wdsrB","report":"style_report__AfFUg","actions":"style_actions__lgJSg","actions_btn":"style_actions_btn__EEbSb"};